export enum ThemeMode {
  Dark = 'dark',
  Light = 'light',
}
